import { render, staticRenderFns } from "./ClassProgress.vue?vue&type=template&id=79454d17&scoped=true&"
import script from "./ClassProgress.vue?vue&type=script&lang=js&"
export * from "./ClassProgress.vue?vue&type=script&lang=js&"
import style0 from "./ClassProgress.vue?vue&type=style&index=0&id=79454d17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79454d17",
  null
  
)

export default component.exports